<div class="custom-price">
  <ng-container *ngIf="knownPrice; else unknownPrice">
    <span class="custom-price__main">{{ price | mainPrice | separator }},</span>
    <span class="custom-price__tails">{{ price | tailsPrice }}</span>
  </ng-container>
  <ng-template #unknownPrice>
    <span class="bold custom-price__main">- - - -,</span>
    <span class="bold custom-price__tails">- -</span>
  </ng-template>
  <span class="custom-price__currency">&nbsp;{{ 'OFFER_SECTION.SHARED.currencyShortcut' | translate }}</span>
</div>
